module.exports = __webpack_public_path__ + "img/lucario-min.9859c541.png";